import { mobileTextCss, TextProps, textCss } from 'common/utils/styleUtilsNew'
import styled from 'styled-components'

export const LanguageSwitcherCurrentLangUi = styled.div<TextProps>`
  display: flex;
  align-items: flex-end;
  cursor: pointer;
  ${textCss};
  ${p => p.theme.isEditorMobileMode && mobileTextCss}
  ${p => p.theme.phone} {
    ${mobileTextCss}
  }
`

export const LanguageSwitcherCurrentLangArrowUi = styled.span<TextProps>`
    display: flex;
    align-items: center;
    padding: 0 5px 15% 5px;
    cursor: pointer;
`
